import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { search } from "../functions/search"
import Post from "../components/post/Post"
import General from "../components/general/General"
import Content from "../components/content/Content"
import moment from "moment"
const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
        marginBottom: '500px',
    },
    header: {
        textAlign: "center"
    }
}));

const MySearch = () => {

    const { mysearch } = useSelector(state => ({ ...state }));

    const [list, setList] = useState([])

    useEffect(() => {

        search(mysearch.content, mysearch.type).then(res => {
            console.log(res)
            setList([...res])

        }).catch(err => {
            console.log(err)
        })

        return (err) => {
            console.log(err)
        }



    }, [mysearch])

    const searchResult = () => {

        if (mysearch.type === 0) {

            return (

                list.map((item, index) => {
                    return (<Post
                        key={index}
                        title={item.title}
                        content={item.content}
                        date={item.date}
                        deadline={item.deadline}
                        done={item.done}
                        comments={item.comments}
                        author={item.author}
                        author_info={item.author_info}
                        goal_participants={item.goal_participants}
                        participants={item.participants}
                        target={item.target}
                        with_prize={item.with_prize}
                        prize={item.prize}
                        num_prize={item.num_prize}
                        credit={item.credit}
                        num_credit={item.num_credit}

                    />)


                })

            )

        } else if (mysearch.type === 1) {

            return (

                list.map((item, index) => {
                    return (<General
                        key={index}
                        _id={item._id}
                        title={item.title}
                        content={item.content}
                        date={item.date}
                        author={item.author}
                        image_urls={item.image_urls}
                        polls={item.polls}
                        comments={item.comments}
                        likes={item.likes}
                        participants_userids={item.participants_userids}
                        done={item.done}
                    />)


                })

            )

        } else {

            list.map((item, index) => {
                return (<Content
                    key={item._id}
                    date={moment(item.date).format("YYYY.MM.DD")}
                    title={item.title}
                    image_urls={item.image_urls}
                    content={item.content} />)


            })

        }

    }


    const styles = useStyles();

    const noResult = () => {
        return (
            <h1> 아무런 검색 결과가 없습니다. </h1>
        )
    }


    return (
        <>
            <div className={styles.header}>
                <h1> 검색 결과 </h1>
            </div>
            <div className={styles.container} >

                {list.length < 1 ? noResult() : searchResult()}
            </div>
        </>
    );
};

export default MySearch;